export enum AchievementId {
    PlayedGobletOfFire = "played-goblet-of-fire",
    PlayedFrozen2 = "played-frozen-2",
    EnemyPlayedForestFire = "enemy-played-forest-fire",
    AtLeastOneSuperPower = "at-least-one-superpower",
    AllSuperPowers = "all-super-powers",
    TotalMoney100 = "100-total-money",
    TotalMoney1000 = "1000-total-money",
    TotalMoney10000 = "10000-total-money",
    FirstLevelCompleted = "first-level-completed",
    WizardLevelCompleted = "farm-level-completed",
    FarmLevelCompleted = "wizard-level-completed",
    DragonLevelCompleted = "dragon-level-completed",
    SpiderLevelCompleted = "spider-level-completed",
    TrollLevelCompleted = "troll-level-completed",
    NecromancerLevelCompleted = "necromancer-level-completed",
    Played100Resources = "played-100-resources",
    Played100Monsters = "played-100-monsters",
    Played100Actions = "played-100-actions",
    Played100Curses = "played-100-curses",
    Played100Tools = "played-100-tools",
}